<header class="site-header">
  <div class="header-wrap">
    <div class="row align-items-center">
      <div class="col-md-2 main-logo">
        <div class="logo">
          <a (mouseover)="brandNotHover()" routerLink="/home-page"><img src="assets/images/new-logo-foy.png"></a>
        </div>
      </div>
      <div class="col-lg-6 col-sm-6 main-menu">
        <div class="navWrap" (click)="slideToggleButton()">
          <div class="enumenu_ul scrollbar-width-none">
            <!-- For Mobile Menu -->
            <div class="logo">
              <a routerLink="/shop-all"><img src="assets/images/logo.svg"></a>
            </div>
            <!-- For Mobile Menu -->
            <div class="menu-wrap">
              <ul id="menu-primary-menu" class="mainMenu">
                <li class="menu-item"><a [ngClass]="(url && url.indexOf('shop-all') != -1) ? 'active' : ''"
                    (click)="goToShopAllWithoutFilters()" (mouseover)="brandNotHover()">SHOP ALL</a></li>
                    <li class="menu-item"><a [ngClass]="(url && url.indexOf('brands-directory') != -1) ? 'active' : ''"
                    (click)="brandClick()" (mouseover)="brandHover()">BRANDS</a></li>
                <!-- <li class="menu-item"><a  [ngClass]="(url && url.indexOf('offers') != -1) ? 'active' : ''" routerLink="/offers" (mouseover)="brandNotHover()">TODAY’S OFFER</a></li>
                <li class="menu-item"><a  [ngClass]="(url && url.indexOf('foy-tv') != -1) ? 'active' : ''" routerLink="/foy-tv" (mouseover)="brandNotHover()">FOY TV</a></li> -->
                <li class="menu-item"><a  [ngClass]="(url && url.indexOf('blog') != -1) ? 'active' : ''" routerLink="/blog" (mouseover)="brandNotHover()">BLOGS</a></li>
              </ul>
            </div>
            <div class="ham-menu">
              <div class="profile-title d-lg-none">
                <div class="profile-text mt-3">
                    <h4>Profile</h4>
                </div>
            </div>
            <div class="profile-upload-image d-lg-none">
                <span>
                    <img  [src]="profileImage ? profileImage : 'assets/images/profile-image.png'">
                </span>
            </div>
            <div class="profile-title d-none">
              <div class="profile-text profile-new-bg mt-3">
                  <h4>Profile and Account</h4>
              </div>
            </div>
              <div class="row justify-content-center" *ngIf="customerMenuLists && customerMenuLists.length > 0">
                <div class="col-12 px-4 d-lg-none tab-profile">
                  <div class="hamburger-section mt-4">
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item" *ngFor="let menu of customerMenuLists; let i = index;">
                        <h2 class="accordion-header" id="headingTwo">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#menu' + i"  aria-expanded="false" [attr.aria-controls]="'menu' + i">
                            {{menu?.name}}
                          </button>
                        </h2>
                        <div [id]="'menu' + i" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                          <div class="accordion-body border-top">
                            <div class="skin-detail-section">
                              <div class="accordion-item" *ngIf="menu && menu.subCategoriesList && menu.subCategoriesList.length > 0">
                                <h2 class="accordion-header" [id]="'subCat-'+i">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#subCatCollapse' + i"  aria-expanded="false" [attr.aria-controls]="'menu' + i">
                                    Sub Category
                                  </button>
                                </h2>
                                <div [id]="'subCatCollapse' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'subCat-'+i" [attr.data-bs-parent]="'#menu' + i">
                                  <div class="accordion-body border-top">
                                    <div class="skin-detail-section">
                                      <ul>
                                        <li class="mb-2" (click)="goToShopAll(menu.name,menu.id,subCat.id)" *ngFor="let subCat of menu?.subCategoriesList; let i = index;"><a>{{subCat?.name}}</a></li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item" *ngIf="menu && menu.skinTypeList && menu.skinTypeList.length > 0">
                                <h2 class="accordion-header" [id]="'subType-'+i">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#subTypeCollapse' + i"  aria-expanded="false" [attr.aria-controls]="'menu' + i">
                                    Skin type
                                  </button>
                                </h2>
                                <div [id]="'subTypeCollapse' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'subType-'+i" [attr.data-bs-parent]="'#menu' + i">
                                  <div class="accordion-body border-top">
                                    <div class="skin-detail-section">
                                      <ul>
                                        <li class="mb-2" (click)="goToShopAllWithSkinType(menu.name,menu.id,skinType.id)" *ngFor="let skinType of menu?.skinTypeList; let i = index;"><a>{{skinType?.name}}</a></li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item" *ngIf="menu && menu.skinConcernList && menu.skinConcernList.length > 0">
                                <h2 class="accordion-header" [id]="'subConcern-'+i">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#subConcernCollapse' + i"  aria-expanded="false" [attr.aria-controls]="'menu' + i">
                                    Skin Concern
                                  </button>
                                </h2>
                                <div [id]="'subConcernCollapse' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'subConcern-'+i" [attr.data-bs-parent]="'#menu' + i">
                                  <div class="accordion-body border-top">
                                    <div class="skin-detail-section">
                                      <ul>
                                        <li class="mb-2" (click)="goToShopAllWithSkinConcern(menu.name,menu.id,skinConcern.id)" *ngFor="let skinConcern of menu?.skinConcernList; let i = index;"><a>{{skinConcern?.name}}</a></li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                            Brands
                          </button>
                        </h2>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                          <div class="accordion-body">
                            <div class="brand-search">
                              <div class="searchbar p-relative d-lg-none d-block">
                                <div id="searchDiv">
                                  <input id="searchInputIn"  type="text"
                                    placeholder="Search..." (input)="searchBrand($event)"/>
                                  <button  class="close"><img src="assets/images/cross.png" alt="icon"
                                      ></button>
                                  <button class="search"><img src="assets/images/search-icon-dark.svg" alt="icon"
                                      ></button>
                                          <ul class="mt-2">
                                            <li class="mb-2" *ngFor="let brand of mGetBrandResponse.data; let i  = index"><a
                                              (click)="viewBrandDetail(brand)"
                                             >{{brand.name}}</a>
                                      </li>
                                          </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="profile-detail-section" (click)="profileClick(true)">
                    <div class="virtual-detail">
                      <span>Profile</span>
                      <div class="virtual-detail-img">
                        <img src="assets/images/profile-right-icon.svg" alt="img">
                      </div>
                    </div>
                  </div>
                  <div class="profile-detail-section" (click)="offer()">
                    <div class="virtual-detail">
                      <span>Offers</span>
                      <div class="virtual-detail-img">
                        <img src="assets/images/profile-right-icon.svg" alt="img">
                      </div>
                    </div>
                  </div>
                        <div id="collapseten" class="accordion-collapse collapse show" aria-labelledby="headingten" data-bs-parent="#accordionExample">
                          <div class="accordion-body">
                            <div class="profile-detail-section" (click)="goToOrders()">
                              <div class="virtual-detail">
                                <span>Orders</span>
                                <div class="virtual-detail-img">
                                  <img src="assets/images/profile-right-icon.svg" alt="img">
                                </div>
                              </div>
                          </div>
                    </div>
                  </div>
                  <div class="icon-detail-section">
                    <div class="share-detail-d">
                      <span>share:</span>
                      <div class="icon-media">
                        <a href="//api.whatsapp.com/send?phone=9920072227&text=Hello Foy" target="_blank">
                          <img src="assets/images/whatsapp-s-icon.svg" alt="icon">
                        </a>
                        <a href="https://www.linkedin.com/company/foyforyou/mycompany/" target="_blank">
                          <img src="assets/images/linkedin-s-icon.svg" alt="icon">
                        </a>
                        <a href="https://www.instagram.com/foy_foryou" target="_blank">
                          <img src="assets/images/instagram-s-icon.svg" alt="icon">
                        </a>
                        <a href="https://twitter.com" target="_blank">
                          <img src="assets/images/twitter-s-icon-new.svg" alt="icon">
                        </a>
                      </div>
                    </div>
                    <div class="nav-section-detail">
                      <ul>
                        <li><a href="blog">blogs</a></li>
                        <li><a href="faq">FAQs</a></li>
                        <li><a href="contact-us">Contact us</a></li>
                        <li><a href="about-us">About us</a></li>
                      </ul>
                    </div>
                    <div class="profile-detail-section mt-4"  *ngIf="userData"  (click)="logout()">
                      <div class="virtual-detail logout-detail">
                        <div class="virtual-detail-img">
                          <img src="assets/images/Logout-icon.png" alt="img">
                        </div>
                        <span>logout</span>
                      </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="menu-close-new" (click)="closeMobileMenu()"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-4  header-link-icons">

        <div class="searchbar p-relative d-lg-flex d-none">
          <div id="searchDiv" [ngClass]="show ? 'searchbar-open' : ''">
            <input id="searchInputIn" (focusin)="onFocusEvent(true)"  [(ngModel)]="text"  (keyup)="getCustomer()" type="text" />
            <button *ngIf="show || showNoData" class="close"><img src="assets/images/cross.png" alt="icon"
                (click)="closeSearchBar()"></button>
            <button class="search-b"><img src="assets/images/search-icon.svg" alt="icon"
                (click)="getCustomer(true)"></button>
            <div class="searchbar-content" id="searchbar-content" *ngIf="show">
              <div class="search-content-box scrollbar">
                <span id="searchbar-product" *ngIf="productList && productList.length > 0">PRODUCTS</span>
                <ul *ngIf="productList && productList.length > 0">
                  <li *ngFor="let product of productList; let i = index">
                    <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                    <a (click)="showProduct(product)">{{product.name}}</a>
                  </li>
                </ul>
                <span id="searchbar-brand" *ngIf="brandList && brandList.length > 0">Brands</span>
                <ul *ngIf="brandList && brandList.length > 0">
                  <li *ngFor="let brand of brandList; let i = index">
                    <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                    <a (click)="viewBrandDetail(brand)">{{brand.name}}</a>
                  </li>
                </ul>
                <span id="searchbar-category" *ngIf="categoryList && categoryList.length > 0">Sub Categories</span>
                <ul *ngIf="categoryList && categoryList.length > 0">
                  <li *ngFor="let category of categoryList; let i = index">
                    <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                    <a
                      (click)="goToShopAll(category.subCategory_name,category.category_id,category.subCategory_id)">{{category.subCategory_name}}</a>
                  </li>
                </ul>
                <span id="searchbar-skinConcern" *ngIf="skinConcernsList && skinConcernsList.length > 0">Skin
                  Concerns</span>
                <ul *ngIf="skinConcernsList && skinConcernsList.length > 0">
                  <li *ngFor="let skinConcern of skinConcernsList; let i = index">
                    <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                    <a
                      (click)="goToShopAllWithSkinConcern(skinConcern.name,skinConcern.category_id,skinConcern.id)">{{skinConcern.name}}</a>
                  </li>
                </ul>
                <span id="searchbar-skinType" *ngIf="skinTypeList && skinTypeList.length > 0">SkinTypes</span>
                <ul *ngIf="skinTypeList && skinTypeList.length > 0">
                  <li *ngFor="let skinType of skinTypeList; let i = index">
                    <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                    <a
                      (click)="goToShopAllWithSkinType(skinType.name,skinType.category_id,skinType.id)">{{skinType.name}}</a>
                  </li>
                </ul>
              </div>
            </div>
              <div  class="brand-p-not-found searchbar-content m-0" id="searchbar-content" *ngIf="showNoData">
                <img class="search-icon-new" src="assets/images/search-black-nav.svg" alt="icon">
                 No Records Found !
              </div>
              <div  class="brand-p-not-found searchbar-content" id="searchbar-content" *ngIf="showOldData && (arrSearchHistory && arrSearchHistory.length > 0)">
                <ul *ngIf="arrSearchHistory && arrSearchHistory.length > 0">
                  <li class="cursor" (click)="selectText(query)" *ngFor="let query of arrSearchHistory; let i = index">
                    <span class="search-icon-new"><img src="assets/images/search-history-icon.png" alt="icon"></span>
                   <small> {{ query }}</small>
                  </li>
                </ul>
              </div>
          </div>
        </div>

        <!-- search bar End  -->
    <!-- mobile search icon start  -->
    <div class="search-icon-mobile d-lg-none d-flex" (click)="mobileserch()">
      <a id="search-br"><img src="assets/images/search-icon.svg" alt="icon" /></a>
    </div>
        <div class="likeIcon">
          <a (click)="goToProductList()"><img src="assets/images/likeProduct.svg">
            <label *ngIf="mWishlistData.length > 0">{{mWishlistData.length}}</label></a>
        </div>
        <div class="cartIcon">
          <a data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"><img
              src="assets/images/shopping-cart.svg">
            <label
              *ngIf="mAddUpdateCartModuleResponse.data.length > 0">{{mAddUpdateCartModuleResponse.data.length}}</label>
          </a>
        </div>
        <div class="userIcon">
          <div class="dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
              aria-expanded="false" (click)="profileClick()">
              <figure><a><img [src]="profileImage"></a></figure>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" *ngIf="userData"
              id="toggleProfileMenu">
              <li><a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#login-popup"
                  (click)="openUserProfile()">User Profile</a></li>
              <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="searchbar p-relative m-seach mobile-search">
        <div id="searchDiv" [ngClass]="show ? 'searchbar-open' : ''">
          <input id="searchInputIn" (focusin)="onFocusEvent(true)" [(ngModel)]="text" (keyup)="getCustomer()" type="text" placeholder="search"/>
          <button *ngIf="show || showNoData" class="close"><img src="assets/images/cross.png" alt="icon" (click)="closeSearchBar()"></button>
          <button class="search-b"><img src="assets/images/search-black-nav.svg" alt="icon"
              (click)="getCustomer(true)"></button>
          <div class="searchbar-content" id="searchbar-content" *ngIf="show">
            <div class="search-content-box scrollbar">
              <span id="searchbar-product" *ngIf="productList && productList.length > 0">PRODUCTS</span>
              <ul *ngIf="productList && productList.length > 0">
                <li *ngFor="let product of productList; let i = index">
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <a (click)="showProduct(product)">{{product.name}}</a>
                </li>
              </ul>
              <span id="searchbar-brand" *ngIf="brandList && brandList.length > 0">Brands</span>
              <ul *ngIf="brandList && brandList.length > 0">
                <li *ngFor="let brand of brandList; let i = index">
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <a (click)="viewBrandDetail(brand)">{{brand.name}}</a>
                </li>
              </ul>
              <span id="searchbar-category" *ngIf="categoryList && categoryList.length > 0">Sub Categories</span>
              <ul *ngIf="categoryList && categoryList.length > 0">
                <li *ngFor="let category of categoryList; let i = index">
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <a
                    (click)="goToShopAll(category.subCategory_name,category.category_id,category.subCategory_id)">{{category.subCategory_name}}</a>
                </li>
              </ul>
              <span id="searchbar-skinConcern" *ngIf="skinConcernsList && skinConcernsList.length > 0">Skin Concerns</span>
              <ul *ngIf="skinConcernsList && skinConcernsList.length > 0">
                <li *ngFor="let skinConcern of skinConcernsList; let i = index">
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <a
                    (click)="goToShopAllWithSkinConcern(skinConcern.name,skinConcern.category_id,skinConcern.id)">{{skinConcern.name}}</a>
                </li>
              </ul>
              <span id="searchbar-skinType" *ngIf="skinTypeList && skinTypeList.length > 0">SkinTypes</span>
              <ul *ngIf="skinTypeList && skinTypeList.length > 0">
                <li *ngFor="let skinType of skinTypeList; let i = index">
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <a
                    (click)="goToShopAllWithSkinType(skinType.name,skinType.category_id,skinType.id)">{{skinType.name}}</a>
                </li>
              </ul>
            </div>
          </div>
  
            <div  class="brand-p-not-found searchbar-content " id="searchbar-content" *ngIf="showNoData">
  
              <img class="search-icon-new" src="assets/images/search-black-nav.svg" alt="icon">
               No Records Found !
            </div>
  
            <div  class="brand-p-not-found searchbar-content" id="searchbar-content" *ngIf="showOldData && (arrSearchHistory && arrSearchHistory.length > 0)">
              <ul *ngIf="arrSearchHistory.length > 0">
  
                <li class="cursor" (click)="selectText(query)" *ngFor="let query of arrSearchHistory; let i = index">
                  <span class="search-icon-new"><img src="assets/images/search-history-icon.png" alt="icon"></span>
                  <small>{{ query }}</small>
                </li>
              </ul>
            </div>
  
  
        </div>
      </div>
    </div>
  </div>
</header>

<!-- cart start -->

<div class="offcanvas offcanvas-end cart-offcanvas" tabindex="-1" id="offcanvasRight"
  aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-body cart-offcanvas-content mt-4 scrollbar-width-none"  *ngIf="!offers">
    <div class="cart-title-detail">
      <div class="cart-title">
        <h4>YOUR CART</h4>
        <span *ngIf="(totalAmountForShipping) < 499">You are ₹{{cartAmount}} away from <b>free shipping!</b></span>
        <span *ngIf="(totalAmountForShipping) >= 499">You are eligible for <b>free shipping!</b></span>
      </div>
      <div class="cart-right-image">
        <img src="assets/images/cart-icon.svg" alt="cart" />
      </div>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div *ngIf="mAddUpdateCartModuleResponse.data.length > 0">

      <!-- new cart design start  -->
      <div class="p-delivery-box"
      *ngFor="let cartItem of mAddUpdateCartModuleResponse.data; let i = index;" class="cart-added-detail" [ngClass]="{'no-pointer-events': cartItem?.productdetail.isLoading, '': !cartItem?.productdetail.isLoading}">

                      <i *ngIf="cartItem?.productdetail.isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': cartItem?.productdetail.isLoading, '': !cartItem?.productdetail.isLoading}"></i>
                      <div class="product-delivery-box">
                          <div class="p-left-box-content">
                              <div class="p-img">
                                  <img [src]="cartItem?.productdetail?.imageList && cartItem?.productdetail?.imageList.length > 0 && cartItem?.productdetail?.imageList[0]?.path ? cartItem?.productdetail.imageList[0].path : 'assets/images/default-product.png'"
                                  alt="cart-image" />
                              </div>
                              <div class="p-img-content">
                                  <a class="capital">{{cartItem?.productdetail?.brand?.name}}</a>
                                  <h4>{{cartItem?.productdetail?.name}}</h4>
                                  <div class="p-size"*ngIf="cartItem?.productdetail?.extras[0] && cartItem?.productdetail?.extras[0].color_list && cartItem?.productdetail?.extras[0].color_list[0].color != null && cartItem?.productdetail?.extras[0].color_list[0].color != ''"
                                  [ngStyle]="{'background': '' + cartItem?.productdetail?.extras[0].color_list[0].color + ''}"
                                  class="cart-color">
                                 </div>
                                 <span class="p-size" *ngIf="cartItem?.productdetail?.size"> Size: {{cartItem?.productdetail?.size}}</span>
                                  <div class="p-quality">Quantity:</div>
                                  <div class="q-wrap">
                                      <button (click)="removeCartItem(cartItem?.productdetail , i)">-</button>
                                      <input class="q-count" type="text" [value]="cartItem?.qty" readonly />
                                      <button type="button" id="add" class="q-add"
                                      (click)="addCartItem(cartItem?.productdetail , i)">+</button>
                                  </div>
                              </div>
                          </div>
                          <div class="p-right-box-content">
                              <a (click)="deleteCartItem(cartItem?.productdetail , i)"><img src="/assets/images/delete-checkout.svg" alt="delete"></a>

                              <a *ngIf="!cartItem?.like" (click)="addRemoveWishlist(cartItem, 'wishlist')"><i class="fa-regular fa-heart set-color"></i></a>

                              <a *ngIf="cartItem?.like" (click)="addRemoveWishlist(cartItem, 'wishlist')"><i class="fa-solid fa-heart set-color"></i></a>
                          </div>
                      </div>
                      <hr>
                      <div class="p-total">
                          <span>total</span>
                          <div class="total" *ngIf="!showDiscountOnTotal">
                              <span *ngIf="!showDiscountOnTotal && cartItem?.discountAppliedAmount && cartItem?.discountType == 'fix'">
                                ₹{{cartItem?.discountAppliedAmount}}</span>
                              <span *ngIf="!showDiscountOnTotal && cartItem?.discountAppliedAmount && cartItem?.discountType == 'percentage'">
                                ₹{{cartItem?.discountAppliedAmount}}</span>
                              <span
                              [ngClass]="cartItem?.discountAppliedAmount ? 'p-line-through' : ''">₹{{calculateIndividualTotal(cartItem?.qty
                                || 1, cartItem?.productdetail?.your_price)}}</span>
                          </div>
                          <div class="total" *ngIf="showDiscountOnTotal">
                              <span>₹{{calculateIndividualTotal(cartItem?.qty || 1,
                                  cartItem?.productdetail?.your_price)}}</span>
                          </div>
                      </div>
        </div>
    </div>

    <div *ngIf="mAddUpdateCartModuleResponse.data.length < 1" class="color-black">
      <div>Add some products to the cart.</div>
    </div>
    <div *ngIf="mAddUpdateCartModuleResponse.data.length > 0" class="cart-price-detail">
      <div class="cart-content-detail">
        <div class="cart-price-title">price details</div>
        <div class="cart-price-title justify-content-end">price details</div>
      </div>
      <div class="cart-content-detail">
        <div class="cart-price-text">MRP</div>
        <div class="cart-price-number">₹{{subTotalAmount}}</div>
      </div>
      <div class="cart-content-detail" *ngIf="discountAmount > 0">
        <div class="cart-price-text">cart discount</div>
        <div class="cart-price-number">₹{{discountAmount}}</div>
      </div>
      <div class="cart-content-detail">
        <div class="cart-price-text">shipping</div>
        <div class="cart-price-number"><span>₹{{shippingCharge}}</span></div>
      </div>
      <div class="cart-content-detail">
        <div class="cart-price-title">you pay</div>

        <div class="cart-price-title justify-content-end">₹{{discountId ? calculateTotalAmount() : totalAmountWithoutDiscount}}</div> 
      </div>
    </div>
    <div *ngIf="mAddUpdateCartModuleResponse.data.length > 0" class="cart-grand-total">
      <div class="cart-price-title">grand total</div>
      <div class="cart-price-title justify-content-end">₹{{discountId ? calculateTotalAmount() : totalAmountWithoutDiscount}}</div> 
    </div>
    <div class="p-offer" *ngIf="mAddUpdateCartModuleResponse.data.length > 0">
      <a (click)="clickOffers('on')">
          <div class="p-left-offer">
              <div class="p-offer-image">
                  <img src="/assets/images/offer-checkout.png" alt="offer">
              </div>
              <span>{{discountId ? discountCode : 'Offers'}}</span>
          </div>
          <div class="p-right-offer">
              <img src="/assets/images/right-checkout.png" alt="arrow">
          </div>
      </a>
  </div>
    <div *ngIf="mAddUpdateCartModuleResponse.data.length > 0" class="cart-checkout-btn">
      <button (click)="checkoutOrder()">checkout</button>
      <button class="continue-btn"><a href="shop-all">continue shopping</a></button>
    </div>

    <!-- Empty card design  -->
    <div class="empty-card-new" *ngIf="mAddUpdateCartModuleResponse.data.length < 1">
      <div class="empty-card">
        <div class="empty-card-icon">
          <img src="assets/images/empty-card.svg" alt="icon">
        </div>
        <span>Your Shopping cart is empty</span>
        <small>Add items to view cart</small>
      </div>
      <button class="start-btn"  data-bs-dismiss="offcanvas" (click)="goToShopAllWithoutFilters()">Start Shopping</button>
    </div>
    <!-- wishlist Empty card design  -->
    <div class="empty-card-new" *ngIf="(mAddUpdateCartModuleResponse.data.length < 1) && (wishlist && wishlist.length < 1)">
      <div class="empty-card">
        <div class="empty-card-icon">
          <img src="assets/images/wishlist-empty.svg" alt="icon">
        </div>
        <span>No items in your wishlist</span>
        <small>Add items to wishlist now!</small>
      </div>
      <button class="start-btn"  data-bs-dismiss="offcanvas" (click)="goToShopAllWithoutFilters()">Add items to wishlist</button>
    </div>

    <div class="offcanvas-add-to-wishlist">
      <div class="p-wishlist" *ngIf="wishlist && wishlist.length > 0">
        <h4>Add from wishlist</h4>
      </div>
      <div class="h-product-boxes scrollbar-width-none" *ngIf="wishlist && wishlist.length > 0">
        <div class="h-product-boxes-cart" *ngFor="let wishList of wishlist; let i  = index">
          <app-product-box [color]="wishList?.productdetail?.category?.color" [product]="wishList" [mAddUpdateCartModule]="mAddUpdateCartModule" [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse" [mWishlistData]="wishlist"  [productType]="'wishlist'"></app-product-box>
        </div>
      </div>
    </div>

  </div>
  <div #content class="scroll-section scrollbar-width-none">
    <div class="offer-content m-2" *ngIf="offers" >
      <div class="offer-title" (click)="clickOffers('off')">
        <img src="/assets/images/profile-left-icon.svg" alt="icon">Offers
      </div>

      <div class="no-offer" *ngIf="discountList.length < 1">
        <span>There are no offers currently</span>
      </div>
      <ng-container *ngIf="discountList && discountList.length > 0">
        <div class="mb-3" *ngFor="let discount of discountList; let i = index">
          <div class="coupon-box" [ngClass]="discount.discount_code == discountCode ? 'disable' : ''">
            <div class="offer-code">
              <span><img
                  [src]="discount.discount_code == discountCode  ? '/assets/images/coupon-dark.png' : '/assets/images/coupon.png'"
                  alt="coupon" /></span>
            </div>
            <div class="offer-code-all">
              <div class="offer-code-left-side">
                <span>{{discount.discount_code}}</span>
                <small><b>{{discount.name}}</b></small>
                  <small [innerHTML]="discount?.description"></small>
                  <small class="save-text-color"
                  *ngIf="discount.amount == 0 && (discount.max_amount > (subTotalAmount*discount.percentage / 100))">*save upto
                  Rs. 
                  {{subTotalAmount*discount.percentage / 100}} on this order!</small>
                <small class="save-text-color"
                  *ngIf="discount.amount == 0 && (discount.max_amount < (subTotalAmount*discount.percentage / 100))">*save
                  Rs.
                  {{discount.max_amount}} on this order!</small>
                <small class="save-text-color" *ngIf="discount.amount > 0">*save Rs.
                  {{discount.amount}} on this order!</small>
              </div>
              <div class="offer-code-Apply">
                <a *ngIf="discount.discount_code != discountCode"
                  (click)="applyDiscount(discount.discount_code)">Apply</a>
                <a *ngIf="discount.discount_code == discountCode" (click)="removeDiscount()">Remove</a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- cart end -->

<app-login-popup></app-login-popup>

<!-- brand hover html start -->

<section class="brand-hover" id="brand-hover-id" [ngClass]="brandClickActive ? 'active' : ''" (mouseleave)="brandNotHover()">
  <div class="brand-hover-detail">
    <div class="row">
      <div class="col-lg-4">
        <div class="b-left-hover-detail">
          <div class="search-detail">
            <form>
              <input type="text" placeholder="Search Brand" (input)="searchBrand($event)" />
            </form>
            <div class="brand-title">
              <h5>Top Brands</h5>
            </div>
            <div class="brand-p" *ngIf="mGetBrandResponse.data && mGetBrandResponse.data.length > 0; else noData">
              <div class="brands-content scrollbar">
                <div class="brands-scroll-view">
                  <div *ngFor="let alpha of alphabets; let i = index">
                      <div class="brand-alphabatic-name">
                          <div class="alphabatic-title" [id]="alpha">{{alpha}}</div>
                          <div class="alphabatic-name">
                              <ul class="b-left-content">
                                  <li *ngFor="let brand of mGetBrandResponse.data; let i  = index"><a
                                          (click)="viewBrandDetail(brand)"
                                          *ngIf="brand.name.startsWith(alpha.toUpperCase()) || brand.name.startsWith(alpha.toLowerCase())">{{brand.name}}</a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
                <div class="list-for-barand">
                  <ul class="b-right-alphabatics">
                    <li *ngFor="let alpha of alphabets; let i = index" (click)="scrollToAlphaView(alpha)"><a>{{alpha}}</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <ng-template  #noData>
              <div class="brand-p-not-found">
                No Data Found !
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="brand-tabs ">
          <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Popular</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">only at foy</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">new launches</button>
            </li>
          </ul>
          <div class="tab-content scrollbar" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
              <div class="brand-icon-image">
                <div class="row">
                  <ng-container *ngFor="let brandImage of brandImageList;let i = index">
                  <div *ngIf="brandImage && brandImage.brand_type == '1'"  class="col-lg-4"  (click)="viewBrandDetail(brandImage,true)">
                    <div class="brand-logo-image">
                      <a><img appPreLoading [lazyLoad]="brandImage?.logo_image" alt="brand-logo"></a>
                    </div>
                  </div>
                </ng-container>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
              <div class="brand-icon-image">
                <div class="row">
                  <ng-container *ngFor="let brandImage of brandImageList;let i = index">
                  <div *ngIf="brandImage && brandImage.brand_type == '2'" class="col-lg-4" (click)="viewBrandDetail(brandImage,true)">
                    <div class="brand-logo-image">
                      <a><img appPreLoading [lazyLoad]="brandImage?.logo_image" alt="brand-logo"></a>
                    </div>
                  </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
              <div class="brand-icon-image">
                <div class="row">
                  <ng-container *ngFor="let brandImage of brandImageList;let i = index">
                    <div *ngIf="brandImage && brandImage.brand_type == '3'" class="col-lg-4" (click)="viewBrandDetail(brandImage,true)">
                      <div class="brand-logo-image">
                        <a><img appPreLoading [lazyLoad]="brandImage?.logo_image" alt="brand-logo"></a>
                      </div>
                    </div>
                    </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>